module.exports = __webpack_public_path__ + "static/map-62bc613f6198d4cd6b35dc72703b787b.png";